import { Card, CardBody, Col } from "reactstrap";
import { CKEditorExample } from "../../../../Utils/Constants";
import CardHeaderCommon from "../../../../Utils/CommonComponents/CardHeaderCommon";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const Editor = () => {
  const content = "Hello!, This is content.";

  return (
    <Col sm="12">
      <Card>
        <CardHeaderCommon title={CKEditorExample} />
        <CardBody>
          <CKEditor editor={ClassicEditor} data={content} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default Editor;
